import type { TweetCreateRequestMediaItemType } from './tweetCreateRequestMediaItemType';

export type TweetCreateRequestMediaItem = {
  id: string;
  type: TweetCreateRequestMediaItemType;
  url: string;
};
